var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            { attrs: { size: "small", "label-position": "top" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("basicData.BusinessTime") } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "date",
                              clearable: "",
                              "picker-options": _vm.pickerOptions,
                              "value-format": "yyyy-MM-dd",
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                            },
                            model: {
                              value: _vm.queryForm.params.operatorTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "operatorTime",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.operatorTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("GlobalSetObj.client") } },
                        [
                          _c("QueryCustomerCmp", {
                            attrs: { value: _vm.queryForm.params.customerId },
                            on: {
                              change: function (val) {
                                return (_vm.queryForm.params.customerId = val)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("newOrder.CollectionType") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryForm.params.collectType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "collectType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.collectType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.all"),
                                  value: null,
                                },
                              }),
                              _vm._l(
                                _vm.COLLECTION_CATEGORY_TYPE,
                                function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", icon: "el-icon-search" },
              on: { click: _vm.handleQuery },
            },
            [_vm._v(_vm._s(_vm.$t("newOrder.search")))]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-refresh-left" },
              on: { click: _vm.onReset },
            },
            [_vm._v(" " + _vm._s(_vm.$t("operationCenter.reset")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "table-but" },
            [
              _c("RefreshDataCmp"),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value:
                        "btn:finance:reportDashboard:report:dailyCollectionReceivableReport:export",
                      expression:
                        "'btn:finance:reportDashboard:report:dailyCollectionReceivableReport:export'",
                      arg: "remove",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-download",
                  },
                  on: { click: _vm.asyncApiStatisticsExport },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.export")))]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                height: _vm.tableHeightRow.height,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operationCenter.ind"),
                  width: "80px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("GlobalSetObj.client"),
                  align: "left",
                  prop: "customerName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.BusinessTime"),
                  "min-width": "180",
                  align: "left",
                  prop: "operateTimeStr",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOrder.CollectionType"),
                  "min-width": "180",
                  align: "left",
                  prop: "collectTypeStr",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.unit"),
                  "min-width": "180",
                  align: "left",
                  prop: "orderQuantity",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("orderCenterCont.TotalCost"),
                  "min-width": "180",
                  align: "left",
                  prop: "totalFee",
                },
              }),
              _vm._l(_vm.tableColumn, function (item) {
                return [
                  _c("el-table-column", {
                    key: item.code,
                    attrs: { label: item.label, width: "160", prop: item.prop },
                  }),
                ]
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.asyncGetTableData,
                  "size-change": _vm.asyncGetTableData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }